import "./ClassicyButton.scss";
import classNames from "classnames";
import React from "react";

type ClassicyButtonProps = {
  isDefault?: boolean;
  disabled?: boolean;
  onClickFunc?: any;
  children?: any;
  buttonShape?: "rectangle" | "square";
  buttonSize?: "medium" | "small";
  buttonType?: "button" | "submit" | "reset";
};

export const ClassicyButton: React.FC<ClassicyButtonProps> = ({
  isDefault = false,
  buttonType = "button",
  buttonShape = "rectangle",
  buttonSize,
  disabled = false,
  onClickFunc = null,
  children,
}) => {
  return (
    <button
      type={buttonType}
      tabIndex={0}
      role={buttonType}
      className={classNames(
        "classicyButton",
        isDefault ? "classicyButtonDefault" : "",
        buttonShape === "square" ? "classicyButtonShapeSquare" : "",
        buttonSize === "small" ? "classicyButtonSmall" : "",
      )}
      onClick={onClickFunc}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
